import moment from 'dayjs';
import BN from 'bignumber.js';
import { useSelector } from 'react-redux';
import { isCountryBlacklistedSelector } from 'store/entities/config/selectors';

import { getOpenOrdersStatuses, getClosedOrdersStatuses } from 'helpers';

import { InlineLoader } from 'elements/loader';

import { 
  OrdersViewTabs,
  OrderStatusesT,
  OrderStatus,
  OrderState,
  OrderSide,
  OrderType,
  OrderT,
} from 'types';

interface Props {
  currentTab?: string;
  order: OrderT;
  handlerCancelOrder: Function;
  isCancelOrderLoading?: boolean;
  isCancelSignOrderLoading: boolean;
  selectedOrderId?: string;
}

const OrdersTableRow = ({
  currentTab,
  order,
  handlerCancelOrder,
  isCancelOrderLoading,
  isCancelSignOrderLoading,
  selectedOrderId,
}: Props) => {
  const {
    created_at,
    base_currency_id,
    quote_currency_id,
    quantity,
    price,
    side,
    type,
    state,
    status,
    base_currency,
    quote_currency,
    id,
  } = order;

  const isForbiddenCountry = useSelector(isCountryBlacklistedSelector);
  const openOrderStatus: OrderStatusesT = getOpenOrdersStatuses(_t);
  const closedOrderStatus: OrderStatusesT = getClosedOrdersStatuses(_t);

  const setOpenOrderStatus = (status: string, state: string) => {
    if (status === OrderStatus.NotFilled && state === OrderState.Settlement) {
      return openOrderStatus.settlement;
    }
    return openOrderStatus[status];
  };

  const orderCreateTime = moment(created_at).format('MM/DD/YYYY HH:mm:ss');

  const quantityQuote = BN(quantity).multipliedBy(price);
  let orderAmount =
    side === OrderSide.Buy
      ? Number(quantityQuote).toFixed(quote_currency?.precision)
      : Number(quantity).toFixed(base_currency?.precision);
  if (type === OrderType.Market && side === OrderSide.Buy) {
    orderAmount = BN(quantity).toFixed(quote_currency?.precision || 6);
  }

  const orderStatus =
    currentTab === OrdersViewTabs.OpenOrders ? setOpenOrderStatus(status, state) : closedOrderStatus[status];
  const orderStatusError = status === OrderStatus.Rejected || status === OrderStatus.Error;

  return (
    <div className="orders-table-order order-row">
      <span>{orderCreateTime}</span>
      <span>{`${base_currency_id} / ${quote_currency_id}`}</span>
      <span>{`${orderAmount} ${side === OrderSide.Buy ? quote_currency_id : base_currency_id}`}</span>
      <span className={`orders-table-order-${side}`}>{side}</span>
      <span>{price ? price : '-'}</span>
      <span>{orderStatus}</span>
      {currentTab !== OrdersViewTabs.OrderHistory ? (
        <span>
          {(isCancelOrderLoading || isCancelSignOrderLoading) && selectedOrderId === id ? (
            <InlineLoader />
          ) : (
            <span
              className={`orders-table-order-reclaim ${
                isCancelOrderLoading || isCancelSignOrderLoading ? 'disabled' : ''
              }`}
              onClick={() => !isForbiddenCountry && handlerCancelOrder(order, orderStatusError ? true : false)}
            >
              {orderStatusError ? _t('Reclaim', 'VIEW_ORDERS.RECLAIM') : _t('Cancel', 'VIEW_ORDERS.CANCEL')}
            </span>
          )}
        </span>
      ) : (
        <span />
      )}
    </div>
  );
};

export default OrdersTableRow;
